import React from 'react'
import styles from './ThankYouContent.module.css'

export default function ThankYouContent() {
    return (
        <div className={styles.content}>
            <div className={styles.figure}>
                <div className={styles.figureInner}>
                    <img
                        src='/pages/business/foodslabo/logo.png'
                        alt='Foodslabo'
                    />
                    <h1>採用DXプラットフォーム</h1>
                    <p className={styles.figureInnerText}>
                        自社のこだわりが伝わる採用を。
                        <br />
                        会社の想いに共感できる転職を。
                    </p>
                </div>
            </div>
            <h2>
                お問い合わせいただき、
                <br />
                誠にありがとうございます。
            </h2>
            <p>
                <span className={styles.orange}>1営業日以内</span>
                に、弊社担当からお電話・メールにてご案内いたします。
                <br />
                導入開始後、最短1営業日で求人掲載が可能となります。
                <span className={styles.br2}>
                    土日祝の場合は、返信にお時間をいただく場合がございます。予めご了承ください。
                </span>
            </p>
            <p>
                また、ご入力いただいたメールアドレスに受付完了メールをお送りいたしました。
                <span className={styles.br}>
                    受付完了メールが届かない場合、大変お手数ですが
                    <span className={styles.orange}>
                        <a href='tel:0120313704'>お電話(0120-313-704)</a>
                    </span>
                    で
                </span>
                <span className={styles.br}>お問い合わせください。</span>
            </p>
            <div className={styles.campaignBanner}>
                <img
                    src='/pages/business/foodslabo/scout_banner.png'
                    alt='PC版の15求人作成代行オプション'
                />
            </div>
            <div
                className={`${styles.campaignBanner} ${styles.campaignBannerSp}`}
            >
                <img
                    src='/pages/business/foodslabo/scout_banner_sp.png'
                    alt='スマホ版の15求人作成代行オプション'
                />
            </div>
        </div>
    )
}
